export var BlueFilterType;
(function (BlueFilterType) {
    BlueFilterType["BRANDS"] = "brands";
    BlueFilterType["CONDITIONS"] = "conditions";
})(BlueFilterType || (BlueFilterType = {}));
